<template>
  <client-only>
    <div>
      <div class="email-field-wrapper">
        <v-text-field
          v-model="model"
          :label="!model ? displayUsersEmail : formLabel"
          solo
          :rules="emailRules"
          prepend-inner-icon="mdi-email-outline"
          :append-icon="UserNotExistsIcon ? 'mdi-check' : null"
          :class="fieldClass"
          required
          rounded
          outlined
          autocomplete="new-email"
          :disabled="btnDisabled"
          @blur="validateUserExists"
          ref="emailNewField"
          @keyup="alertError = false"
          dense
          dir="auto"
          auto
          @focus="isUserFocus = true"
          @input="emitClear"
        />
        <SmallSpinner
          v-show="showSpinner"
          class="SmallSpinner"
          :top="12"
          :right="60"
        />
      </div>
      <v-alert
        :value="alertError"
        transition="fade"
        :dismissible="isDismissible"
        class="run-over-v-alert-padding">
        <span id="custom-alert">שם משתמש קיים במערכת</span>
      </v-alert>
    </div>
  </client-only>
</template>

<script>
import { emailRules } from '@/lib/rules.js';
import { mapState } from 'vuex';
import drushim_lodash from 'lodash';
import SmallSpinner from '@/components/Spinner/SmallSpinner';
import { IS_EMAIL_EXISTS } from '@/lib/api.js';

export default {
  components: { SmallSpinner },
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    newToCheck: {
      type: Boolean,
      required: false,
      default: false
    },
    currentMail: {
      type: String
    }
  },
  data() {
    return {
      btnDisabled: false,
      isUserFocus: false,
      alertError: false,
      formLabel: 'דואר אלקטרוני',
      isDismissible: false,
      UserExistsMessage: null,
      showSpinner: false,
      email: '',
      UserNotExistsIcon: false,
      emailRules
    };
  },
  mounted() {
    this.btnDisabled = this.disabled;
  },

  computed: {
    ...mapState({
      userEmail: state => drushim_lodash.get(state.auth, 'state.auth.user.UserProfile.Email')
    }),

    userEmailFromStore() {
      return this.userEmail;
    },
    model: {
      get() {
        return this.userEmailFromStore;
      },
      set(val) {
        this.email = val;
      }
    },

    displayUsersEmail() {
      return this.currentMail ? this.currentMail : this.formLabel;
    }
  },

  watch: {
    model() {
      if (this.model) {
        this.email = this.model;
      }
    },
    email() {
      this.applyNewEmail();
    }
  },

  methods: {
    emitClear() {
      this.$emit('clearEmailValidation');
    },
    redirectToLogin() {
      /**
       * Emit the email to login dialog if user exists
       */
      this.$nuxt.$emit('hasEmail', this.emailNew);
      document.querySelector('.login-btn').click();
    },

    applyNewEmail() {
      this.$emit('newEmail', this.email);
    },

    async validateUserExists() {
      if (!this.isUserFocus) {
        return;
      }

      if (this.email.length > 3 && this.editable && this.newToCheck) {
        this.showSpinner = true;
        this.btnDisabled = true;
        const emailToVerify = encodeURIComponent(this.email);
        const isEmailExistsApi = `${IS_EMAIL_EXISTS}?email=${emailToVerify}`;

        try {
          const { data: emailExists = null } = await this.$axios.get(
            isEmailExistsApi
          );

          if (emailExists) {
            this.alertError = true;
            this.UserNotExistsIcon = false;
          } else {
            this.alertError = false;
            this.UserNotExistsIcon = true;
          }

          this.btnDisabled = false;
          this.showSpinner = false;
        } catch (error) {
          console.error(error);
        }
      } else {
        return false;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.email-field-wrapper {
  position: relative;
}
.v-input--is-disabled:not(.v-input--is-readonly) {
  pointer-events: none;
  background: none;
  border: 0;
  box-shadow: none;
}
#placeholder {
  text-align: right;
}

#custom-alert {
  color: rgb(255, 82, 82);
  font-size: 12px;
  font-weight: 400;
}

.run-over-v-alert-padding {
  padding: 0px 12px;
}
</style>
